import React from 'react'
import { BreachNotification } from './BreachNotification'
import { BreachEvent } from 'common/events/breachEventTypes'
import { StyledLogInButton } from './BreachNotification.styled'
import { AuthenticationProvider } from 'component-library/user-registration/authentication/AuthenticationProvider'

interface Props {
    breachDeal: string
    articleId: string
    breachCreativeName: string
    onEvent: (event: BreachEvent) => void
}

export const BreachNotificationWrapper: React.FC<Props> = ({
    breachDeal,
    articleId,
    breachCreativeName,
    onEvent,
}) => (
    <BreachNotification
        isLoggedIn={false}
        Login={() => (
            <AuthenticationProvider onEvent={onEvent}>
                {({ onLoginClick }) => (
                    <StyledLogInButton onClick={onLoginClick}>Log in</StyledLogInButton>
                )}
            </AuthenticationProvider>
        )}
        breachDeal={breachDeal}
        articleId={articleId}
        breachCreativeName={breachCreativeName}
        onEvent={onEvent}
    />
)

BreachNotificationWrapper.displayName = 'BreachNotificationWrapper'
